import React from 'react';

const Maps = ({ card }) => {
  return (
    <div className="map z-index-none">
          <iframe
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.98323840858!2d-46.6976842!3d-23.712292599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce4fbb2b551259%3A0x62751fd9ca502fd2!2sRua%20Ant%C3%B4nio%20Carlos%20Tacconi%2C%20261%20-%20a%20-%20Vila%20Santa%20Maria%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2004810-020!5e0!3m2!1spt-BR!2sbr!4v1745008467424!5m2!1spt-BR!2sbr'
            style={{
              border: "0",
              marginBottom: "-7px",
              width: "100%",
              height: "400px",
            }}
            loading="lazy"
          ></iframe>
        </div>
  );
};

export default Maps;
